import axios from 'axios';
import apiConfig from '../api.config';

export default function deleteGuestlink({ hotelId, guestlinkId }) {
  const {
    host,
    URIs: { deleteGuestlink },
  } = apiConfig;

  let uri = `${host}${deleteGuestlink}`
    .replace(':hotelId', hotelId)
    .replace(':guestlinkId', guestlinkId);

  return axios
    .delete(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
